export class PersonInsightsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The favorites and blocks the person made and the ones made toward them (newest first, at most 100). */
    relationships(userId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/relationships`, auth: true });
    }
    /** The tickets the person filed or that were opened about them (newest first). */
    supportTickets(userId, opts = {}) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/support-tickets${limitQuery(opts)}`, auth: true });
    }
    /** The safety incidents the person reported or is the subject of (newest first). */
    safetyIncidents(userId, opts = {}) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/safety-incidents${limitQuery(opts)}`, auth: true });
    }
    /** The legal documents the person accepted and the data-rights (export / erasure) requests they made (newest first, at most 100 each). */
    legal(userId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/users/${encodeURIComponent(userId)}/legal`, auth: true });
    }
}
const limitQuery = (opts) => (opts.limit !== undefined ? `?limit=${encodeURIComponent(String(opts.limit))}` : '');
//# sourceMappingURL=person-insights.js.map